import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from 'react-i18next';
import { Toolbar } from "../../components/ui/toolbar/toolbar.component";
import { Action } from "../../types/toolbar";
import CustomModal from "../../components/ui/modal/modal.component";
import { useState } from "react";
import JobIssueForm from "../../components/service/jobIssueForm.component";
import { useHasPermission } from "../../contexts/auth";

export const JobIssuesListActions = () => {
  const { t } = useTranslation();
  const [addJobIssueOpened, setAddJobIssueOpened] = useState<boolean>(false);
  const canAddJobIssue = useHasPermission("service.add_jobissue");

  const actions: Action[] = [{
    id: "add-new-issue",
    icon: <AddIcon />,
    label: t("Add new issue"),
    onClick: () => { setAddJobIssueOpened(true) },
    disabled: !canAddJobIssue
  }];

  const handleJobIssueAdded = () => {
    setAddJobIssueOpened(false);
    window.dispatchEvent(new Event('jobIssueAdded'));
  };

  return (
    <>
      <Toolbar actions={actions} />
      <CustomModal
        opened={addJobIssueOpened}
        setOpened={setAddJobIssueOpened}
        title={t("Add new issue")}
        content={
          <JobIssueForm onSuccess={handleJobIssueAdded} />
        }
      />
    </>
  );
};
